<div class="float-left">
    <span [className]="disabled ? 'input-name disabled': 'input-name' ">{{name}}</span>
</div>
<div class="float-left switchBox">
    <label class="switch">
        <input type="checkbox" [formControl]="toggleControl" data-test="first-name">
        <span class="slider round test"></span>
    </label>
</div>
